type RuntimeEnv = {
  BASE_API_URL: string;
};

const runtimeConfig: RuntimeEnv = {
  BASE_API_URL: import.meta.env.VITE_API_URL,
};

const buildTimeConfig = import.meta.env;

export const config = {
  ...buildTimeConfig,
  ...runtimeConfig,
};